import { memo } from "react";
import { useTranslation } from "react-i18next";
import * as React from 'react';

import CasesFilterIcon from "assets/CasesFilterIcon";
import CustomSort from "core/components/global/customSort/customSort";
import DateRangePicker from "core/components/global/dateRangePicker/dateRangePicker";
import SeveritySelect from "core/components/global/severitySelect/severitySelect";

import Menu from '@mui/material/Menu';
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { BadgeCount, FiltersAppliedBadge } from "../ac2Alerts/alerts.styled";
import { FilterTitle } from "../ac2Alerts/alerts.styled";
import { CustomButtonContainer } from "core/components/global/buttons/button/customButton.styled";
import HomeToolbar from "core/components/global/homeToolbar/homeToolbar";
import { Filters1, Filters2 } from "core/components/global/homeToolbar/homeToolbar.styles";
import { getAlertFilters } from "modules/ac2/services/alertService";
import { getOCSFSeverityNameFromNumber } from "core/utils/common";

interface FiltersProps {
  filterData: any;
  setIsFilterModalOpen: (boolean) => void;
  deleteFilter: (arg1: string, arg2: string) => void;
  setFilterData: any;
  clearSearch: () => void;
}

function Filters({filterData, setIsFilterModalOpen, deleteFilter, setFilterData, clearSearch}: FiltersProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();
  
  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <HomeToolbar>
      <Filters1>
        <CustomButtonContainer variant="outlined"
            sx={{borderColor: 'grey'}}
            id="active-filter-menu-toggle"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClickListItem}
            disabled={Object.entries(filterData["filterTerms"]).length > 0 || filterData["searchTerm"] !== "" ? false : true}
          >

            <FilterTitle className="pe-2 d-flex">{t("INCIDENTS_PAGE.FILTERSAPPLIED")}</FilterTitle>
            <FiltersAppliedBadge>
              <BadgeCount>{filterData.totalFilters}</BadgeCount>
            </FiltersAppliedBadge>
        </CustomButtonContainer>
        <Menu
          id="active-filter-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={{padding: "0"}}
        >
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell align="left" variant="head">Column</TableCell>
                  <TableCell align="left" variant="head">Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <>
                  {Object.entries(filterData["filterTerms"]).map(([category, categoryValue]: [string, string], index: number) => (
                    // Check if the category is not "filter[assignedto]" before rendering
                    category !== "filter[assignedto]" && (
                      typeof categoryValue === 'string' && categoryValue.includes(",") ? (
                        categoryValue.split(',').map((value, valueIndex) => (
                          <TableRow key={`${category}-${valueIndex}`}>
                            <TableCell component="th" scope="row">
                              <CloseIcon onClick={() => deleteFilter(category, value)}/>
                            </TableCell>
                            <TableCell align="left">{category}</TableCell>
                            <TableCell align="left">
                              {category.toLowerCase().includes("severity") && !isNaN(Number(value.trim()))
                                ? getOCSFSeverityNameFromNumber(t, Number(value.trim())).toUpperCase()
                                : value.trim().toUpperCase()}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            <CloseIcon onClick={() => deleteFilter(category, categoryValue)}/>
                          </TableCell>
                          <TableCell align="left">{category}</TableCell>
                          <TableCell align="left">{String(categoryValue)}</TableCell>
                        </TableRow>
                      )
                    )
                  ))}
                </>
              </TableBody>
            </Table>
        </Menu>
        
      </Filters1>

      <Filters2>
        <DateRangePicker setFilteredData={setFilterData} />
        
        <CustomButtonContainer
          variant="outlined"
          data-testid="filter-btn"
          className="all-filters"
          onClick={() => setIsFilterModalOpen(true)}
        >
          <FilterTitle className="pe-2">{t("INCIDENTS_PAGE.ALLFILTERS")}</FilterTitle>
          <CasesFilterIcon />
        </CustomButtonContainer>
      </Filters2>
    </HomeToolbar>
  );
}

function AnalystToolbar({headCells, setFilterData, isFilterModalOpen, setIsFilterModalOpen, setPage, filterData, deleteFilter, onFilterCreated, clearSearch}: any) {
  return (
    <>
        <Filters
            filterData={filterData}
            setIsFilterModalOpen={setIsFilterModalOpen}
            deleteFilter={deleteFilter}
            setFilterData={setFilterData}
            clearSearch={clearSearch}
        />
        <CustomSort 
            table_headers={headCells} 
            setFilterData={setFilterData}
            isFilterModalOpen={isFilterModalOpen || false}
            setIsFilterModalOpen={setIsFilterModalOpen}
            setPage={setPage}
            getFiltersFunction={getAlertFilters}
            onFilterCreated={onFilterCreated}
        />
    </>
  );
}

export default memo(AnalystToolbar);